import { EnvironmentProviders, ErrorHandler, inject, Injector, isDevMode, makeEnvironmentProviders } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { FirebaseError } from 'firebase/app';

import { SnackbarService } from '@rent2end/core/snackbar';
import { TranslationStore } from '@rent2end/core/translation';
import { UpperSnakeCasePipe } from '@rent2end/utils/pipes';

import { firebaseErrorTranslationKeysMap } from './firebase-error-translation-keys.map';

export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);
  private snackbarService = inject(SnackbarService);
  private upperSnakeCasePipe = inject(UpperSnakeCasePipe);

  handleError(error: unknown, fallbackTranslationKey?: string) {
    if (isDevMode()) { console.error(error) }

    let errorTranslationKey = fallbackTranslationKey ?? 'COMMON.ERRORS.GENERIC';

    switch (true) {
      case error instanceof FirebaseError:
        errorTranslationKey = firebaseErrorTranslationKeysMap.get(error.code) ?? errorTranslationKey;
        break;
      case error instanceof HttpErrorResponse:
        if (error.error.reasonCode) {
          errorTranslationKey = `COMMON.WEB_API_ERRORS.${this.upperSnakeCasePipe.transform(error.error.reasonCode)}`;
        }
        break;
    }

    this.snackbarService.open(this.injector.get(TranslationStore).translate(errorTranslationKey));
  }
}

export const provideGlobalErrorHandler = (): EnvironmentProviders => makeEnvironmentProviders([
  { provide: ErrorHandler, useClass: GlobalErrorHandler },
]);
